import React from "react";

import {CircularProgressbar} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import {i18n} from "translate/i18n";

import fileDownload from 'js-file-download'
import {getFile} from "services/Files.service";
import {Outlet} from "react-router";
import {Tooltip} from "../Tooltip";
import {Link} from "react-router-dom";
import {changeStatus} from "../../pages/Collect/actions";

function FileList({files, isFetching, param}) {

    const handleDownload = (url, filename) => {
        const response = getFile(url);
        fileDownload(response?.data, filename)
    }

    return (
        <>
            <Outlet/>

            <table className={`table mb-0 align-middle`}>
                <tbody>
                {!files?.length &&
                    <tr>
                        <td>{i18n.t('upload.tableRecords')}</td>
                    </tr>
                }

                {files?.map((file, index) => (
                    <React.Fragment key={index}>
                        <tr className={`${isFetching && "text-muted"}`}>
                            <td width={10}>
                                <Tooltip label={i18n.t('buttons.more')}>
                                    <button className="btn btn-primary btn-sm" type="button"
                                            data-bs-toggle="collapse" data-bs-target={`#collapse-${index}-${param}`}
                                            aria-expanded="true" aria-controls={`collapse-${index}-${param}`}>
                                        <i className="bi bi-plus"/>
                                    </button>
                                </Tooltip>
                            </td>

                            <td>
                                <p className="mb-0 text-muted bold-500 text-sm">{i18n.t('label.archive')}</p>
                                <p className="mb-0 text-sm">{file.filename}</p>
                            </td>

                            <td className="text-sm" width={200}>
                                <p className="mb-0 mt-0 bold-500">{file.username}</p>
                                <p className="mb-0 text-muted"> {file.created_at} </p>
                            </td>

                            <td>
                                {!file.uploaded && !file.error &&
                                    <CircularProgressbar
                                        styles={{
                                            root: {width: 30},
                                            path: {stroke: 'green'}
                                        }}
                                        strokeWidth={8}
                                        value={file.progress}
                                    />
                                }

                                {file.uploaded &&
                                    <Tooltip label={i18n.t('label.downloadArchive')}>
                                        <button className="btn btn-sm btn-outline-primary" onClick={() => {
                                            handleDownload(file.url, file.url)
                                        }}>
                                            <i className="bi bi-download"/>
                                        </button>
                                    </Tooltip>
                                }

                                {file.error &&
                                    <i className="bi bi-x-circle text-danger fs-3" style={{display: "flex"}}/>}
                            </td>
                        </tr>
                        <tr className="border-top-0">
                            <td colSpan={5} className="p-0">
                                <div id={`collapse-${index}-${param}`} className="accordion-collapse collapse"
                                     aria-labelledby={param} data-bs-parent={`#collapse-${index}-${param}`}>
                                    <div className="accordion-body table-responsive p-0">

                                        <div className="row bg-theme mx-0">
                                            <div className="col py-3">
                                                <span
                                                    className="fw-bolder px-3 ">{i18n.t('filelist.total')}:</span> {file.title?.length}
                                            </div>
                                        </div>

                                        <table className="table mb-0 align-middle">
                                            <thead className="bg-light">
                                            <tr>
                                                <th className="py-3">{i18n.t('label.title')}</th>
                                                <th className="py-3">Status</th>
                                                <th/>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {file.title?.map((item, index) =>
                                                <tr key={index}>
                                                    <td><span className="text-muted fw-bolder">{item.codigo}  - </span> {param === 'goals' ? item.titulo_meta : item.titulo}</td>
                                                    <td>
                                                    <span className={`badge ${changeStatus(item.status).bg}`}>
                                                        {changeStatus(item.status).label}
                                                    </span>
                                                    </td>
                                                    <td>
                                                        { param === 'indicators' ?
                                                            <Tooltip label={i18n.t('label.editIndicator')}>
                                                                <Link
                                                                    to={`/collect/indicator/edit/${item.id}`}
                                                                    className={`btn btn-outline-primary btn-sm bi-pencil ${isFetching && "disabled"}`}
                                                                />
                                                            </Tooltip>
                                                            :
                                                            <Tooltip label="Editar meta">
                                                                <Link
                                                                    to={`/workflow/goals/${item.id}`}
                                                                    className={`btn btn-outline-primary btn-sm bi-pencil ${isFetching && "disabled"}`}
                                                                />
                                                            </Tooltip>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </React.Fragment>
                ))}
                </tbody>
            </table>
        </>

    )
}

export default FileList
